/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Default_TypeInputs */

const en_sch_err_default_type = /** @type {(inputs: Sch_Err_Default_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The default type cannot be archived: new items get it when no type is named.`)
};

const de_sch_err_default_type = /** @type {(inputs: Sch_Err_Default_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Standardtyp lässt sich nicht archivieren: Neue Vorgänge bekommen ihn, wenn kein Typ genannt wird.`)
};

/**
* | output |
* | --- |
* | "The default type cannot be archived: new items get it when no type is named." |
*
* @param {Sch_Err_Default_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_default_type = /** @type {((inputs?: Sch_Err_Default_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Default_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_default_type(inputs)
	return en_sch_err_default_type(inputs)
});